import { SxProps, Theme } from '@mui/system';

const itemCommon = {
  borderTopRightRadius: '30px',
  borderBottomRightRadius: '30px',
  padding: '5px 20px',
  marginRight: '15px',
};

export const drawerPaper: SxProps<Theme> = {
  top: '90px',
  backgroundColor: 'transparent',
  height: '80vh',
  overflowX: 'hidden',
  borderRight: 'none',
};

export const DrawerPaperAnchorLeft: SxProps<Theme> = {
  borderRight: 'none',
};

export const root: SxProps<Theme> = {
  ...itemCommon,
  '&.Mui-selected': {
    backgroundColor: '#E4F2DA',
  },
  color: '#878787',
  fontSize: '12px',
};

export const selected: SxProps<Theme> = {};

export const primary: SxProps<Theme> = {
  color: '#70AD47',
};

export const primaryV1: SxProps<Theme> = {
  color: '#56CD9D',
};

export const version: SxProps<Theme> = {
  position: 'absolute',
  bottom: '15px',
  width: 200,
};

export const highlightBackground = {
  backgroundColor: '#E4F2DA',
};

export const rootInsideCollapse: SxProps<Theme> = {
  '&.Mui-selected': {
    backgroundColor: '#E4F2DA',
  },
  ...itemCommon,
  borderRadius: '30px',
};

export const selectedInsideCollapse: SxProps<Theme> = {
  backgroundColor: '#F0F0F0',
  borderRadius: '30px',
};

export const selectedInsideCollapseV1: SxProps<Theme> = {
  backgroundColor: 'unset',
};

export const nested: SxProps<Theme> = {
  paddingLeft: '16px',
  marginRight: '4px',
  marginLeft: '2px',
  marginTop: '4px',
};

export const listIcon = {
  height: '20px',
  width: '20px',
  marginRight: '10px',
};

export const collapseListIcon = {
  position: 'absolute',
  left: '-2px',
};

export const rootText: SxProps<Theme> = {
  fontSize: '14px',
};
